import axiosInstance from ".";

export const uploadImage = (payload) => {
  const { file } = payload;
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("/image/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
